import { beginTask, endTask } from 'redux-nprogress';
import { redirect, NOT_FOUND } from 'redux-first-router';
import routes from '../../../../routes.global';
import viewNames from '../../../../../store/actions/view.types';
import { selectPredictionsState } from '../../module/predictions';
import { loadToolDescriptions } from '../../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'matchupAnalysis';
export const selectMatchupAnalysisState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  matchupId: null,
  formulaId: null,
  matchups: [],
  matchupData: {},
  pregame: {},
  home_team_stats: [],
  away_team_stats: [],
  home_team_record_summary: null,
  away_team_record_summary: null,
  home_team_record: [],
  away_team_record: [],
  home_team_defensive_matchup: {},
  away_team_defensive_matchup: {},
  hasLoaded: false,
  listHasLoaded: false,
  error: null,
};

const matchupAnalysisReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default matchupAnalysisReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_MATCHUP_ANALYSIS_REQUEST = `${STORE_KEY}/LOAD_MATCHUP_ANALYSIS_REQUEST`;
export const LOAD_MATCHUP_ANALYSIS_SUCCESS = `${STORE_KEY}/LOAD_MATCHUP_ANALYSIS_SUCCESS`;
export const LOAD_MATCHUP_ANALYSIS_ERROR = `${STORE_KEY}/LOAD_MATCHUP_ANALYSIS_ERROR`;
export const LOAD_MATCHUP_LIST_SUCCESS = `${STORE_KEY}/LOAD_MATCHUP_LIST_SUCCESS`;
export const LOAD_MATCHUP_LIST_ERROR = `${STORE_KEY}/LOAD_MATCHUP_LIST_ERROR`;

export const loadMatchupAnalysisRequest = ({ matchupId, formulaId }) => ({
  type: LOAD_MATCHUP_ANALYSIS_REQUEST,
  payload: { matchupId, formulaId },
});
export const loadMatchupAnalysisSuccess = data => ({
  type: LOAD_MATCHUP_ANALYSIS_SUCCESS,
  payload: { data },
});
export const loadMatchupAnalysisError = error => ({
  type: LOAD_MATCHUP_ANALYSIS_ERROR,
  payload: { error },
});
export const loadMatchupListSuccess = matchups => ({
  type: LOAD_MATCHUP_LIST_SUCCESS,
  payload: { matchups },
});
export const loadMatchupListError = error => ({
  type: LOAD_MATCHUP_LIST_ERROR,
  payload: { error },
});

actions[LOAD_MATCHUP_ANALYSIS_REQUEST] = (
  state,
  { payload: { matchupId, formulaId } },
) => ({
  ...state,
  matchupId,
  formulaId,
  hasLoaded: false,
});

actions[LOAD_MATCHUP_ANALYSIS_SUCCESS] = (state, { payload: { data } }) => ({
  ...state,
  hasLoaded: true,
  ...data,
});

actions[LOAD_MATCHUP_LIST_SUCCESS] = (state, { payload: { matchups } }) => ({
  ...state,
  listHasLoaded: true,
  matchups,
});

actions[LOAD_MATCHUP_ANALYSIS_ERROR] = (state, { payload }) => ({
  ...state,
  error: payload.error,
});

actions[LOAD_MATCHUP_LIST_ERROR] = (state, { payload }) => ({
  ...state,
  error: payload.error,
});

export const loadMatchupList = () => async (
  dispatch,
  getState,
  { api },
) => {
  try {
    const state = getState();
    const { week, season: year } = selectMatchupAnalysisState(state).matchupData;
    const { formulaId } = selectMatchupAnalysisState(state);
    const { matchups } = await api.projections.getPredictions({ year, week, formulaId });
    dispatch(loadMatchupListSuccess(matchups));
  } catch (error) {
    console.error(error);
    dispatch(loadMatchupListError(error));
  }
};

export const loadMatchupAnalysis = ({ matchupId, formulaId }) => async (
  dispatch,
  getState,
  { api },
) => {
  try {
    dispatch(beginTask());
    dispatch(loadMatchupAnalysisRequest({ matchupId, formulaId }));
    const { summary } = await api.projections.getMatchupAnalysis({
      matchupId,
      formulaId,
    });
    const {
      home_team_stats,
      away_team_stats,
      home_team_record_summary,
      away_team_record_summary,
      home_team_record,
      away_team_record,
      home_team_defensive_matchup,
      away_team_defensive_matchup,
      pregame_summary,
      betting_info,
      pregame_home_analysis,
      pregame_away_analysis,
      ...matchupData
    } = summary;
    const pregame = {
      summary: pregame_summary,
      home_analysis: pregame_home_analysis,
      away_analysis: pregame_away_analysis,
      betting_info: betting_info,
    };
    dispatch(
      loadMatchupAnalysisSuccess({
        home_team_stats,
        away_team_stats,
        home_team_record_summary,
        away_team_record_summary,
        home_team_record,
        away_team_record,
        home_team_defensive_matchup,
        away_team_defensive_matchup,
        pregame,
        matchupData,
      }),
    );
  } catch (error) {
    console.error(error);
    dispatch(loadMatchupAnalysisError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const MATCHUP_ANALYSIS_VIEW = `${STORE_KEY}/MATCHUP_ANALYSIS_VIEW`;
viewNames[MATCHUP_ANALYSIS_VIEW] = 'MatchupAnalysis';
routes[MATCHUP_ANALYSIS_VIEW] = {
  path: '/in-season/predictions/analysis/:matchupId/:formulaId',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const matchupState = selectMatchupAnalysisState(state);
    const { matchupId, formulaId } = state.location.payload;
    const {
      matchupId: currentMatchupId,
      formulaId: currentFormulaId,
    } = matchupState;
    const matchupListLength = selectPredictionsState(state).matchups.length || selectMatchupAnalysisState(state).matchups.length;
    // if (!matchupId || !formulaId) {
    //   const action = redirect({ type: NOT_FOUND });
    //   return dispatch(action);
    // }
    // if (!formulaId || !currentFormulaId) formulaId = selectFormulasState(state).defaultFormula;
    await dispatch(loadToolDescriptions());
    if (matchupId !== currentMatchupId || formulaId !== currentFormulaId) {
      await dispatch(loadMatchupAnalysis({ matchupId, formulaId }));
      !matchupListLength && await dispatch(loadMatchupList());
    }
    return null;
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Predictions/MatchupAnalysis/module/analysis.js